export const shoppingEn = {
  shopping: {
    nav: {
      title: 'Shopping',
    },
    lists: {
      title: 'Shopping lists',
      subtitle: 'Shared lists for your family',
      create: 'New list',
      namePlaceholder: 'List name (e.g. Home, Weekend)',
      namePlaceholderShort: 'List name',
      createTitle: 'New shopping list',
      empty: 'No shopping lists yet. Create your first one.',
      items: 'items',
      open: 'Open',
      delete: 'Delete list',
      deleteConfirm: 'Delete this list?',
    },
    list: {
      keepSync: {
        create: 'Sync with Google Keep',
        menu: 'Google Keep',
        syncNow: 'Sync now',
        autoSync: 'Auto-sync',
        unlink: 'Unlink from Keep',
        synced: 'Synced to Keep at {time}',
        error: 'Last Keep sync failed',
      },
      back: 'Back to lists',
      addProduct: 'Add product',
      searchPlaceholder: 'Search or type a product…',
      searching: 'Searching…',
      recentSuggestions: 'Recent',
      popularSuggestions: 'Popular',
      moreOptions: 'Quantity, unit and category',
      quickAddPlaceholder: 'e.g. "2 kg flour" or "1 cup sugar"',
      quickAddLabel: 'Quick add from text',
      quickAdd: 'Parse',
      add: 'Add',
      addCategory: 'Assign category',
      nameExample: 'flour',
      quantityExample: '500',
      summationHint: 'The same ingredient with quantity and unit merges automatically (e.g. 1 cup flour + 130 g).',
      empty: 'This list is empty. Add your first item.',
      remaining: 'remaining',
      checked: 'done',
      uncategorized: 'Uncategorized',
      namePlaceholder: 'Item name',
      quantity: 'Qty',
      unit: 'Unit',
      category: 'Category',
      noUnit: 'No unit',
      noCategory: 'No category',
      detectedCategory: 'Category: {category}',
      incrementQuantity: 'Increase quantity',
      decrementQuantity: 'Decrease quantity',
      summed: 'Σ',
      summedHint: 'Item summed from a recognized ingredient',
      rename: 'Rename',
      save: 'Save',
      cancel: 'Cancel',
      filterPlaceholder: 'Filter items…',
      groupByCategory: 'Group by category',
      sortBy: 'Sort',
      sortCategory: 'By category',
      sortName: 'A–Z',
      sortCheckedLast: 'Unchecked first',
      noMatches: 'No items match your filter.',
    },
    categories: {
      title: 'Categories',
      description: 'Editable categories for your family',
      manage: 'Manage categories',
      namePlaceholder: 'Category name',
      add: 'Add category',
      empty: 'No categories yet',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      done: 'Done',
    },
    toasts: {
      listCreated: 'List created',
      listRenamed: 'List renamed',
      listDeleted: 'List deleted',
      listError: 'Something went wrong with the list',
      itemDeleted: 'Item removed',
      itemError: 'Something went wrong with the item',
      categorySaved: 'Category saved',
      categoryDeleted: 'Category deleted',
      categoryError: 'Something went wrong with the category',
    },
  },
}
